import React from 'react';
import ReactDOM from 'react-dom';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import cssVars from 'css-vars-ponyfill';
import App from './App';
import './i18n';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'emoji-mart/css/emoji-mart.css';
import '../../assets/stylesheets/reset.module.css';
import '../../assets/stylesheets/fonts.module.css';
import * as utils from '../../helpers/utils';
import config from '../../config/config';
import rootStore from '../../mobx/stores/rootStore';
import { rootContext } from '../../mobx/bridge';

if (process.env.NODE_ENV === 'development') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render'); // eslint-disable-line
  whyDidYouRender(React);
}

Bugsnag.start({
  apiKey: config.bugsnagKey,
  autoNotify: !config.isHostedLocally,
  plugins: [new BugsnagPluginReact(React)],
});

window.name = utils.windowName;

let chatHolder;
let cpHeaderElement;

const calculateHeight = () => {
  if (chatHolder) {
    let value;
    let cpHeaderHeight = '0px';

    if (cpHeaderElement?.clientHeight && cpHeaderElement?.dataset?.header === 'menu') {
      const mobileFix =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) // new ipad pro
          ? ' - 52px '
          : '';

      value = `calc(100vh - ${cpHeaderElement.clientHeight}px ${mobileFix})`;
      cpHeaderHeight = `${cpHeaderElement.clientHeight}px`;
      rootStore.commonStore.setCpHeaderHeight(cpHeaderElement.clientHeight);
    } else {
      value = `${document.documentElement.clientHeight}px`;
    }

    cssVars({
      variables: { size: value, header: cpHeaderHeight },
    });
  }
};

window.addEventListener('load', () => {
  chatHolder = document.getElementById('kukui-connect');
  if (!chatHolder) {
    chatHolder = document.createElement('div');
    chatHolder.setAttribute('id', 'kukui-connect');
  }

  [cpHeaderElement] = document.getElementsByClassName('header');
  if (cpHeaderElement) {
    const viewPortTag = document.createElement('meta');
    viewPortTag.id = 'viewport';
    viewPortTag.name = 'viewport';
    viewPortTag.content = 'minimum-scale=1, initial-scale=1, width=device-width, user-scalable=no';
    document.getElementsByTagName('head')[0].appendChild(viewPortTag);
  }

  calculateHeight();

  document.getElementsByTagName('body')[0].appendChild(chatHolder);

  rootStore.receivingEvents.AttachLoginSocketReceivingEvents();

  const ErrorBoundary = Bugsnag.getPlugin('react');

  ReactDOM.render(
    <rootContext.Provider value={rootStore}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </rootContext.Provider>,
    chatHolder
  );
});

window.addEventListener('resize', () => {
  calculateHeight();
});
